import { createBaseAction } from '@essent/common';

export const setConsentPackageView = createBaseAction<boolean>(
  '[Consent Package View] Set consent package view'
);
